export default __webpack_public_path__ + "static/media/4065.48920a41.png";